import { useState, useEffect } from 'react';
import SearchSelect from "../ui-components/SearchSelect";


export const ServiceConfiguratorSelectServiceComponent = (
  {
    value,
    onChange,
    services,
  }
) => {
  const [servicesOptions, setServicesOptions] = useState(services?.map(
    (s) => ({
      label: s.name,
      value: s.id,
    })
  ));

  return (
    <SearchSelect
      options={servicesOptions}
      value={servicesOptions?.find((s) => s.value === value)}
      label="Service"
      onChange={onChange}
    />
  )
}